import { Box } from '@mui/material'
import React from 'react'
import { MediaType } from '../../../data/model/questionnaire'
import { ConjointAttributeItem } from './ConjointAttributeItem'
import { ConjointAttribute } from './ConjointQuestion.container'

interface Props {
  attributes: ConjointAttribute[]
  entryId: string
  questionnaireId: string
  hasMissingAppearanceImageErrors?: boolean
  onUpdateAttribute: (attributeId: string, name: string) => void
  onRemoveAttribute: (attributeId: string) => void
  onAddAttributeValue: (attributeId: string) => void
  onUpdateAttributeValue: (
    attributeId: string,
    valueId: string,
    value: string
  ) => void
  onRemoveAttributeValue: (attributeId: string, valueId: string) => void
  onToggleAppearance: (attributeId: string) => void
  onUploadAttributeValueMedia: (
    attributeId: string,
    optionId: string,
    mediaUrl: string,
    mediaName: string,
    mediaType: MediaType,
    renderedMediaUrl: string
  ) => Promise<void>
  onRemoveAttributeValueMedia: (
    attributeId: string,
    optionId: string
  ) => Promise<void>
}

export const ConjointAttributesList: React.FC<Props> = ({
  attributes,
  entryId,
  questionnaireId,
  hasMissingAppearanceImageErrors,
  onUpdateAttribute,
  onRemoveAttribute,
  onAddAttributeValue,
  onUpdateAttributeValue,
  onRemoveAttributeValue,
  onToggleAppearance,
  onUploadAttributeValueMedia,
  onRemoveAttributeValueMedia
}) => {
  return (
    <Box sx={{ p: 2, width: '100%' }}>
      {attributes.map((attribute) => (
        <ConjointAttributeItem
          key={attribute.id}
          attribute={attribute}
          entryId={entryId}
          questionnaireId={questionnaireId}
          hasMissingAppearanceImageErrors={hasMissingAppearanceImageErrors}
          showDeleteButton={attributes.length > 2}
          onUpdateAttribute={onUpdateAttribute}
          onRemoveAttribute={onRemoveAttribute}
          onAddAttributeValue={onAddAttributeValue}
          onUpdateAttributeValue={onUpdateAttributeValue}
          onRemoveAttributeValue={onRemoveAttributeValue}
          onToggleAppearance={onToggleAppearance}
          onUploadAttributeValueMedia={onUploadAttributeValueMedia}
          onRemoveAttributeValueMedia={onRemoveAttributeValueMedia}
        />
      ))}
    </Box>
  )
}
